export function formatNumber(value: string | number, places: number): string {
  if (typeof value === 'number') value = value.toFixed(20);

  if (places >= 0 && places <= 20) {
    return parseFloat(value).toFixed(places);
  } else if (
    places < 0 &&
    (value.length <= 20 || (value.includes('.') && value.indexOf('.') < 20))
  ) {
    const powTen = Math.pow(10, -places);
    return (Math.floor(parseFloat(value) / powTen) * powTen).toFixed(0);
  } else {
    // Places over 20 result in scientific notation, so don't touch them!
    // We've opted to constrain them out of the schema instead.
    return value;
  }
}
